import { HimuraInject } from 'himura';
import * as dd from 'dingtalk-jsapi';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';
import * as T_T from 'cryface';

@HimuraInject.NamedService('DingTalkAuth')
export class DingTalkAuth {
    private _code: string = '';
    get Code(): string {
        return this._code;
    }
    set Code(code: string) {
        this._code = code;
    }

    private _userInfo: any = undefined;
    get UserInfo(): any {
        return this._userInfo;
    }
    set UserInfo(user: any) {
        this._userInfo = user;
    }

    // for testing property
    public temp: any;

    private _accessToken: string = '';
    get AccessToken(): string {
        return this._accessToken;
    }
    set AccessToken(token: string) {
        this._accessToken = token;
    }

    private _succeed: boolean = false;
    get IsSucceed(): boolean {
        return this._succeed;
    }
    set IsSucceed(succeed: boolean) {
        this._succeed = succeed;
    }

    public async authenticate() {
        const code = await this._dingAuthFunction();
        const result = await this._getUserInfo(code);
        if (T_T.simpleDetect(result)) {
            if (result.errorCode === 200) {
                const userInfo = result.data;
                this._code = code;
                return userInfo;
            }
        } else {
            return undefined;
        }
    }

    public isDingTalk(): boolean {
        return !(dd.env.platform === 'notInDingTalk');
    }

    private async _dingAuthFunction(): Promise<any> {
        return new Promise<any>((resolve: any, reject: any) => {
            dd.ready(async () => {
                try {
                    const result = await dd.runtime.permission.requestAuthCode({
                        corpId: new CommonConfig().dingTalk.corpId,
                    });
                    resolve(result.code);
                } catch (e) {
                    resolve('400');
                }
            });
        });
    }

    private async _getUserInfo(code: string) {
        const config: CommonConfig = new CommonConfig();
        const authoreyHost = config.authoreyHost;
        // const apiHost = 'http://192.168.0.125:9527';
        try {
            const result = await AxiosPromise.get(`${authoreyHost}/ding/talk/auth/user/withoutAuth?code=${code}`);
            return result;
        } catch (e) {
            alert('Login Failed.');
            return undefined;
        }
    }
}
